import { Button, Card, PasswordField } from "components";
import { fieldLimits } from "config";
import { useFormikContext } from "formik";
import FormError from "pages/accounts-onboarding/components/form-error/FormError";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import Paths from "routes/Paths";

import type { ResetPasswordModel } from "../../models";

import styles from "../ResetPassword.module.css";

const ResetPasswordForm = () => {
	const { t } = useTranslation("accountsPage");
	const { isSubmitting } = useFormikContext<ResetPasswordModel>();

	return (
		<Card className={styles.card}>
			<div className={styles.form}>
				<header className={styles.header}>
					<h1 className={styles.title}>{t("resetPassword.title")}</h1>
					<p className={styles.subtitle}>{t("resetPassword.subtitle")}</p>
				</header>
				<FormError />
				<div className={styles.body}>
					<PasswordField
						autoComplete="new-password"
						label={t("resetPassword.newPasswordLabel")}
						maxLength={fieldLimits.password}
						name="newPassword"
						placeholder={t("resetPassword.newPasswordPlaceholder")}
					/>
					<PasswordField
						autoComplete="new-password"
						label={t("resetPassword.confirmPasswordLabel")}
						maxLength={fieldLimits.password}
						name="confirmPassword"
						placeholder={t("resetPassword.confirmPasswordPlaceholder")}
					/>
				</div>
				<footer className={styles.footer}>
					<Button className={styles.submitButton} disabled={isSubmitting} type="submit" fullWidth>
						{t("resetPassword.submit")}
					</Button>
					<Link className={styles.backLink} to={Paths.signIn}>
						{t("resetPassword.backToSignIn")}
					</Link>
				</footer>
			</div>
		</Card>
	);
};

export default ResetPasswordForm;
